import { Platform } from 'react-native'

import Box, { BoxProps } from 'app/components/base/Box/'

interface ParsedHtmlStylesContainerProps {
  sx?: BoxProps['sx']
}

const ParsedHtmlStylesContainer: RFC<ParsedHtmlStylesContainerProps> = ({
  children,
  sx
}) => {
  return (
    <Box
      sx={{
        ...Platform.select({
          web: {
            '& p': {
              textAlign: 'justify'
            },
            '& blockquote::before': {
              content: 'open-quote'
            },
            '& blockquote::after': {
              content: 'close-quote'
            },
            '& blockquote': {
              quotes: `"“" "”" "‘" "’"`
            },
            '& a': {
              textDecoration: 'none'
            }
          }
        }),
        ...sx
      }}
    >
      {children}
    </Box>
  )
}

export default ParsedHtmlStylesContainer
